/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const WorkLinesIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 42 43"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190,-1445)">
      <g id="Work-Lines" transform="matrix(1,0,0,1,-392.323,-373.784)">
        <g transform="matrix(0.342972,-1.46981e-16,-5.45974e-17,0.342972,-265.596,1819.77)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(-0.0329906,-1.84766e-17,9.50498e-05,-0.0725909,660.015,1892.34)">
          <path
            d="M1775.07,768.466L1775.07,886.375L1664.82,886.375L1664.82,770.731L1410.9,885.977L1332.84,850.546L1586.86,735.254L1332.55,735.103L1332.4,684.997L1591.03,685.151L1336.69,570.015L1414.55,534.584L1664.82,647.88L1664.82,534.186L1775.07,534.186L1775.07,649.829L2028.98,534.584L2107.05,570.015L1853.03,685.306L2107.34,685.458L2107.49,735.564L1858.19,735.416L2112.51,850.546L2034.65,885.977L1775.07,768.466ZM1720.1,764.37C1785.79,764.37 1839.05,740.134 1838.96,710.28C1838.88,680.427 1785.48,656.19 1719.79,656.19C1654.1,656.19 1600.84,680.427 1600.93,710.28C1601.01,740.134 1654.41,764.37 1720.1,764.37ZM1774.36,429.575L1774.36,497.791L1664.11,497.791L1664.11,429.575L1774.36,429.575ZM1775.78,922.77L1775.78,990.986L1665.53,990.986L1665.53,922.77L1775.78,922.77ZM1102.22,685.183L1252.32,685.272L1252.47,735.378L1102.37,735.289L1102.22,685.183ZM2187.42,685.183L2337.52,685.272L2337.67,735.378L2187.57,735.289L2187.42,685.183ZM1172.95,923.659L1279.09,875.486L1357.15,910.917L1251.01,959.09L1172.95,923.659ZM2087.39,507.528L2193.52,459.355L2271.59,494.786L2165.45,542.959L2087.39,507.528ZM2272.82,923.659L2194.96,959.09L2088.55,910.917L2166.41,875.486L2272.82,923.659ZM1355.99,507.528L1278.13,542.959L1171.72,494.786L1249.57,459.355L1355.99,507.528Z"
            style={{ fill: 'white' }}
          />
        </g>
      </g>
    </g>
  </svg>,
  'WorkLinesIcon',
);
